<template>
  <div class="student-answer">
    <!-- 原来方式展示 -->
    <div v-if="(object_type === 0 || homework_type === 8) && data">
      <!-- 按照客观题方式显示 -->
      <p v-if='getStudentsAnswer.show_way == 0 && getStudentsAnswer.form==5'>
        学员作答：<span v-for='(i,index) in data.question_choices'>
          <span v-for='(j,idx) in (getStudentsAnswer.user_answer.split(","))'>
            <span v-if='i.id==j'>{{String.fromCharCode(index+65)}}</span>
          </span>
        </span>
        正确答案：<span class="answers" v-for='(i,index) in data.question_choices' v-if='i.is_correct == 1'>{{String.fromCharCode(index+65)}}</span>
      </p>
      <p v-if='getStudentsAnswer.show_way == 0 && getStudentsAnswer.user_answer==i.id' v-for='(i,index) in data.question_choices'>
        学员作答：{{String.fromCharCode(index+65)}}
        <span class="answers" v-for='(i,index) in data.question_choices' v-if='i.is_correct == 1'>正确答案：{{String.fromCharCode(index+65)}}</span>
      </p>
      <!-- 按照主观题-文本方式显示 -->
      <div v-if='getStudentsAnswer.show_way == 1'>
        <p class="question_item">学员作答</p>
        <p v-if='parsedUserAnswer' v-html='parsedUserAnswer'></p>
        <p class="cyplayer" v-show='getStudentsAnswer.user_answer_video'>
          <VideoPlayer :id='getStudentsAnswer.user_answer_video'></VideoPlayer>
        </p>
        <p v-if='getStudentsAnswer.user_answer == "" && getStudentsAnswer.user_answer_video == ""'>无</p>
      </div>
      <!-- 按照画布方式显示 -->
      <div class="answerlist" v-if='getStudentsAnswer.show_way == 2'>
        <p class="question_item">学员作答</p>
        <div class="canvas_loop" v-if='getStudentsAnswer.user_answer'>
          <span class="correcting_btn" @click='showMarkPaper'>画笔批改</span>
          <div class="swiper-container">
            <question-swiper
              :ifShowBtn="false"
              :questionsListFromProp="JSON.parse(getStudentsAnswer.user_answer)"
              :qs_id="7"
              canvasId="canvas1"
              canvasWrapper="canvas__wrapper1"
            ></question-swiper>
          </div>
        </div>
      </div>
    </div>
    <!-- 练习册，新的作答方式展示 -->
    <div v-else-if="object_type === 1 && homework_type && homework_type != 8">
      <p class="question_item">学员作答</p>
      <!-- 文本 -->
      <div v-if="homework_type === 1">
        <p v-for="(item, i) in JSON.parse(getStudentsAnswer.user_answer)" :key="i">{{item.content}}</p>
      </div>
      <!-- 图片 -->
      <div v-else-if="homework_type === 2">
        <span class="enclosure" v-for='(file, i) in JSON.parse(getStudentsAnswer.user_answer)' :key="i" @click='material_enclosure(file)'>
          <img src="./img/pic.png" alt="">
        </span>
      </div>
      <!-- 图文 -->
      <div v-else-if="homework_type === 3">
        <div v-for="(item, i) in JSON.parse(getStudentsAnswer.user_answer)" :key="i">
          <p>{{item.content}}</p>
          <span class="enclosure" v-for='(file, j) in item.file' :key="j" @click='material_enclosure(file)'>
            <img src="./img/pic.png" alt="">
          </span>
        </div>
      </div>
      <!-- 语音 -->
      <div v-else-if="homework_type === 4">
        <span class="enclosure" v-for='(file, i) in JSON.parse(getStudentsAnswer.user_answer)' :key="i" @click='material_enclosure(file)'>
          <img src="./img/audio.png" alt="">
        </span>
      </div>
      <!-- 文档 -->
      <div v-else-if="homework_type === 5">
        <span class="enclosure" v-for='(file, i) in JSON.parse(getStudentsAnswer.user_answer)' :key="i" @click='material_enclosure(file)'>
          <img src="./img/attachment.png" alt="">
        </span>
      </div>
      <!-- 视频 -->
      <div v-else-if="homework_type === 6">
        <span class="enclosure" v-for='(file, i) in JSON.parse(getStudentsAnswer.user_answer)' :key="i" @click='material_enclosure(file)'>
          <img src="./img/video.png" alt="">
        </span>
      </div>
      <!-- 画布 -->
      <div v-else-if="homework_type === 7">
        <div class="canvas_loop">
          <span class="correcting_btn" @click='showMarkPaper'>画笔批改</span>
          <div class="swiper-container">
            <question-swiper
              :ifShowBtn="false"
              :questionsListFromProp="JSON.parse(getStudentsAnswer.user_answer)"
              :qs_id="7"
              canvasId="canvas1"
              canvasWrapper="canvas__wrapper1"
            ></question-swiper>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import VideoPlayer from '@/pages/video-previews/index'
import QuestionSwiper from '@/components/question-swiper/question-swiper'
export default {
  props: ['getStudentsAnswer', 'data'],
  data() {
    return {
      object_type: Number(this.$route.params.object_type) // 0, 试卷类型，现有方式展示， 1，练习册，按新字段展示
    }
  },
  components: {
    QuestionSwiper,
    VideoPlayer
  },
  computed: {
    homework_type () {
      if (this.$route.query.homework_type === 'undefined' || this.$route.query.homework_type === undefined || this.$route.query.homework_type === null || this.$route.query.homework_type === '') {
        return null
      } else {
        return Number(this.$route.query.homework_type)
      }
    },
    parsedUserAnswer() {
      const userAnswer = this.getStudentsAnswer.user_answer || ''
      if (!userAnswer) return ''
      
      // 1. 按 #url# 分割字符串
      const parts = userAnswer.split('#url#')
      let html = ''
      
      // 2. 遍历分割后的数组：偶数位是文本，奇数位是图片链接
      for (let i = 0; i < parts.length; i++) {
        const part = parts[i].trim()
        if (!part) continue
        
        if (i % 2 === 0) {
          // 偶数索引 → 文本，直接拼接
          html += part
        } else {
          // 奇数索引 → 图片链接，拼接 img 标签（可自定义样式）
          html += `<img src="${part}" alt="作答图片" style="max-width: 100%; height: auto; margin: 4px 0;">`
        }
      }
      return html
    }
  },
  methods: {
    showMarkPaper () {
      this.$emit('showMarkPaper')
    },
    material_enclosure(item){
      console.log('点击file', item)
      if (item.file_type === 0 || item.file_type == 3) {
        window.open(item.file_url)
      } else if (item.file_type == 1 || item.file_type == 2) {
        let video_window = window.open('')
        let href =  this.$router.resolve({
          path: '/video-preview/' + item.media_id
        })
        video_window.location = href.href
      }
    }
  },
  created(){
  },
  mounted () {
    console.log('rrrrrrrrrrrrrrrrrrrrrrrr', this.$route.params, this.$route.query)
  }
}
</script>

<style lang="less" scoped>
.student-answer{
  font-size: 14px;
}
.question_item{
    font-weight: bold;
    position: relative;
    padding-left: 10px;
    font-size: 14px;
}
.question_item::before{
    content: "";
    position: absolute;
    left: 0;
    top: 3px;
    height: 14px;
    width: 4px;
    border-radius: 2px;
    background-color: #6594fe;
}
.cyplayer{
  padding-right: 20px;
  .jw-time-tip{
    white-space: nowrap;
  }
}
.answerlist{
  // padding-right: 30px;
}
.enclosure{
  display: inline-block;
  width: 24px;
  height: 24px;
  text-align: center;
  line-height: 24px;
  margin-right: 10px;
  border: 1px solid #e6e7e8;
  border-radius: 4px;
  cursor: pointer;
}
.canvas_loop{
  position: relative;
  .correcting_btn{
    position: absolute;
    z-index: 2;
    right: 10px;
    bottom: 65px;
    width: 70px;
    height: 30px;
    color: #6594fe;
    text-align: center;
    line-height: 30px;
    border: 1px solid #6594fe;
    border-radius: 4px;
    background: #ffffff;
    cursor: pointer;
    font-size: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/homework-subject/student-answer.vue